import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useAddQuestion = () => {

    const axios = useAxios();
    const {t} = useTranslation();
    const queryClient = useQueryClient();
    const {message} = App.useApp();

    const addQuestion = async (values: any) => {
        const val = {
            ...values,
            answersHaveCategories: false,
            state: 1,
            categories: values.categories.map((category: any) => ({id: category})),
        }
        try {
            const { data } = await axios.post("/api/questions", val);
            return data;
        } catch (error) {
            throw new Error(t("messages.error.addQuestion"));
        }
    }

    return useMutation({mutationFn: addQuestion, 
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["questions"]});
            message.success(t("messages.success.addQuestion"));
        }
    })
}